import { connect } from 'react-redux';
import { compose } from 'redux';
import AssignmentsPage from './AssignmentsPage';
import {
  actions as assessmentItemsActions,
  selectors as assessmentItemsSelectors,
} from '$data/assessmentItems';
import {
  actions as assignmentsActions,
  selectors as assignmentsSelectors,
} from '$data/assignments';
import {
  actions as providersActions,
  selectors as providersSelectors,
} from '$data/providers';
import { selectors as coreSelectors } from '$data/core';
import { getAssignmentById } from '$data/assignments/assignments.selectors';
import launchTurnitinAssignment from '$utils/launchTurnitinAssignment';
import withAnalyticsHoc from '$utils/withAnalyticsHoc';
import { VIEW_ASSIGNMENTS_PAGE } from '$variables/analyticsEvents';

const createLaunchTurnitinAssignmentFunction = (state) => (assignmentId) => {
  const spaceId = coreSelectors.getCurrentSpace(state).id;
  const user = coreSelectors.getUser(state);
  const assignment = getAssignmentById(state, assignmentId);

  launchTurnitinAssignment({
    user,
    spaceId,
    assignment,
  });
};

const mapStateToProps = (state) => ({
  spaceId: coreSelectors.getCurrentSpace(state).id,
  assessmentItems: assessmentItemsSelectors.getAssessmentItems(state),
  assessmentItemsLoading:
    assessmentItemsSelectors.getAssessmentItemsIsLoading(state),
  assignments: assignmentsSelectors.getParentAssignments(state),
  ltiProviders: providersSelectors.getProvidersById(state),
  ltiProvidersLoading: providersSelectors.getProvidersIsLoading(state),
  assignmentsLoading: assignmentsSelectors.getAssignmentsIsLoading(state),
  error:
    assessmentItemsSelectors.getAssessmentItemsError(state) ||
    assignmentsSelectors.getAssignmentsError(state) ||
    providersSelectors.getProvidersError(state),
  mapAssignmentsLoading:
    assessmentItemsSelectors.mapAssignmentsIsLoading(state),
  mapAssignmentsSuccessful:
    assessmentItemsSelectors.mapAssignmentsIsSuccessful(state),
  mapAssignmentsError: assessmentItemsSelectors.mapAssignmentsError(state),
  isGeneratingCsv: assessmentItemsSelectors.getIsGeneratingCsv(state),
  isInitiatingExport: assessmentItemsSelectors.getIsInitiatingExport(state),
  launchTurnitinAssignment: createLaunchTurnitinAssignmentFunction(state),
  isCreatingAssignment: assignmentsSelectors.getIsCreatingAssignment(state),
  isManualAssignmentsEnabled:
    coreSelectors.getIsManualAssignmentsEnabled(state),
  viewAs: coreSelectors.getViewAs(state),
  isGradePassBackDisabled: coreSelectors.getDisableGradePassBack(state),
});

const mapDispatchToProps = {
  fetchAssessmentItems: assessmentItemsActions.fetchAssessmentItems,
  mapAssignments: assessmentItemsActions.mapAssignmentsToAssessmentItem,
  fetchAssignments: assignmentsActions.fetchAssignments,
  clearMapAssignmentsError: assessmentItemsActions.clearMapAssignmentsError,
  exportGrades: assessmentItemsActions.exportGrades,
  createAssignment: assignmentsActions.createAssignment,
  fetchLtiProviders: providersActions.fetchLtiProviders,
};

const withAnalytics = withAnalyticsHoc({
  eventName: VIEW_ASSIGNMENTS_PAGE,
});

const wrap = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAnalytics
);

export default wrap(AssignmentsPage);
